import type { CategoryTree } from "../models/category";

export const categoryTreeWorld: CategoryTree = {
  nsm: {
    name: "Science",
    subcategories: {
      mth: { name: "Mathematics" },
      phy: { name: "Physics" },
      che: { name: "Chemistry" },
      bio: { name: "Biology" },
      ast: { name: "Astronomy & Cosmos" },
      ear: { name: "Earth Science" },
      eco: { name: "Ecology" },
      mat: { name: "Materials Science" },
      env: { name: "Environmental Science" },
      gen: { name: "Genetics & Evolution" },
      qua: { name: "Quantum Science" },
      sci: { name: "Scientific Method" },
      res: { name: "Research Methods" },
    },
  },
  tae: {
    name: "Technology & Engineering",
    subcategories: {
      art: { name: "Artificial Intelligence" },
      com: { name: "Computer Science" },
      eng: { name: "Engineering Disciplines" },
      rob: { name: "Robotics & Automation" },
      dat: { name: "Data Science" },
      net: { name: "Internet & Networks" },
      emi: { name: "Emerging Technologies" },
      bio: { name: "Biotechnology" },
      sof: { name: "Software Systems" },
      inn: { name: "Future Tech" },
      sus: { name: "Sustainable Technology" },
      cyb: { name: "Cybersecurity" },
    },
  },
  haw: {
    name: "Health & Wellbeing",
    subcategories: {
      phy: { name: "Physical Health" },
      men: { name: "Mental Health" },
      nut: { name: "Nutrition" },
      fit: { name: "Fitness" },
      med: { name: "Medicine & Treatments" },
      pub: { name: "Public Health" },
      pre: { name: "Preventative Care" },
      wel: { name: "Wellness Practices" },
      chr: { name: "Chronic Conditions" },
      lif: { name: "Healthy Aging" },
      alt: { name: "Integrative Health" },
      hea: { name: "Health Systems" },
    },
  },
  aac: {
    name: "Arts & Communication",
    subcategories: {
      vis: { name: "Visual Arts" },
      per: { name: "Performing Arts" },
      mus: { name: "Music & Sound Arts" },
      lit: { name: "Literary Arts" },
      med: { name: "Media Studies" },
      lan: { name: "Linguistics" },
      sto: { name: "Storytelling" },
      des: { name: "Aesthetics" },
      rnp: { name: "Rhetoric" },
      jou: { name: "Journalism" },
      dig: { name: "Digital Arts" },
      cul: { name: "Cultural Expression" },
    },
  },
  awd: {
    name: "Applied Wisdom",
    subcategories: {
      per: { name: "Personal Productivity" },
      hom: { name: "Lifestyle" },
      car: { name: "Career Development" },
      com: { name: "Effective Communication" },
      pro: { name: "Problem Solving" },
      edu: { name: "Skill Acquisition" },
      pas: { name: "Recreation" },
      cul: { name: "Culinary Skills" },
      diy: { name: "Craftsmanship" },
      tra: { name: "Travel" },
      sus: { name: "Sustainable Living" },
    },
  },
  whc: {
    name: "History",
    subcategories: {
      anc: { name: "Ancient Civilizations" },
      med: { name: "Medieval Eras" },
      ear: { name: "Early Modern Period" },
      mod: { name: "Modern History" },
      con: { name: "Contemporary History" },
      reg: { name: "Regional Histories" },
      cul: { name: "Cultural Histories" },
      soc: { name: "Social & Economic History" },
      mil: { name: "Military History" },
      bio: { name: "Historical Figures" },
      phi: { name: "History of Ideas" },
      his: { name: "Historiography" },
    },
  },
};
